<mat-form-field>
    <input [required]="requerido" matInput placeholder="{{placeHolder}}" [matAutocomplete]="auto" [formControl]="control">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="selecionado($event)">
        <mat-option *ngFor="let c of listaClientes" [value]="c">
            {{ c.nome }} - {{ c.id }}
        </mat-option>
    </mat-autocomplete>
    <mat-error>
        <!-- <campo-control-erro [control]="control"></campo-control-erro> -->
    </mat-error>
</mat-form-field>